import React from "react";
import ReadingForm from "components/readingsAndAnamnesisForms/ReadingForm";
import AnamnesisStore from "stores/AnamnesisStore";

const ReadingFormAnamnesis = (props) => {
    const editingId = props.match.params.id;
    return <ReadingForm {...props} editingId={editingId} store={AnamnesisStore} accessor={AnamnesisStore.ANAMNESIS_ACCESSOR} reroute={"/anamnesis"} />;
};

export default ReadingFormAnamnesis;